import gql from 'graphql-tag'

export const GeoItemFragment = gql`
fragment GeoItemFragment on GeoItem {
  id,
  coordinates,
  google_map_url
}
`

const query = gql`
query getDashboardDSGeo($branch: Int) {
  cashAssist {
    getDashboardDSGeo(branch: $branch) {
      ...GeoItemFragment
    }
  }
}
${GeoItemFragment}
`

export default query
